import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: { padding: '24px', background: '#fff', minHeight: '360px' }
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { style: {"color":"#969393","padding":"10px"} }, "Встречи", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Встречи")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Аналитика")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Сотрудники")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Выйти")
const _hoisted_7 = { style: {
            padding: '24px',
            minHeight: '360px',
            background: '#d1ecf1',
          } }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Встречи")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_team_outlined = _resolveComponent("team-outlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_bar_chart_outlined = _resolveComponent("bar-chart-outlined")!
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (!_ctx.route.meta?.layout)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createBlock(_component_a_layout, {
        key: 1,
        style: {"min-height":"100vh"},
        id: "navigate"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_sider, {
            collapsed: _ctx.collapsed,
            "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collapsed) = $event)),
            breakpoint: "lg",
            "collapsed-width": "0"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_a_menu, {
                selectedKeys: _ctx.selectedKeys,
                "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKeys) = $event)),
                theme: "dark",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { key: "1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_team_outlined),
                      _createElementVNode("span", null, [
                        _createVNode(_component_router_link, { to: "/" }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.store.state.user.roles.includes(_ctx.Role.ADMIN))
                    ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_bar_chart_outlined),
                          _createElementVNode("span", null, [
                            _createVNode(_component_router_link, { to: "/analytics" }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.store.state.user.roles.includes(_ctx.Role.ADMIN))
                    ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_user_outlined),
                          _createElementVNode("span", null, [
                            _createVNode(_component_router_link, { to: "/staff" }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["selectedKeys"])
            ]),
            _: 1
          }, 8, ["collapsed"]),
          _createVNode(_component_a_layout, { style: {"background":"#d1ecf1"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_layout_header, { style: {"background":"rgba(255, 255, 255, 0.3)","padding":"0","text-align":"end"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _ctx.logout,
                    style: {"margin-right":"1rem"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_layout_content, { style: {"margin":"0 16px"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_router_view)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_layout_footer, { style: {"text-align":"center","background":"#d1ecf1"} }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}